var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitBurgerSettingsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#F3223C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37846 7.09082H12.3669C12.526 7.09082 12.6549 7.21979 12.6549 7.37846V12.3669C12.6549 12.526 12.526 12.6549 12.3669 12.6549H7.37846C7.21941 12.6549 7.09082 12.526 7.09082 12.3669V7.37846C7.09082 7.21941 7.21979 7.09082 7.37846 7.09082ZM13.957 13.8081H18.9455C19.1042 13.8081 19.2331 13.9371 19.2331 14.0962V19.0846C19.2331 19.2437 19.1042 19.3723 18.9455 19.3723H13.957C13.798 19.3723 13.669 19.2433 13.669 19.0846V14.0962C13.669 13.9371 13.798 13.8081 13.957 13.8081ZM18.6579 14.3838H14.2451V18.7966H18.6579V14.3838ZM7.37846 13.8081H12.3669C12.526 13.8081 12.6549 13.9371 12.6549 14.0962V19.0846C12.6549 19.2437 12.526 19.3723 12.3669 19.3723H7.37846C7.21941 19.3723 7.09082 19.2433 7.09082 19.0846V14.0962C7.09082 13.9371 7.21979 13.8081 7.37846 13.8081ZM12.0793 14.3838H7.66648V18.7966H12.0793V14.3838ZM13.957 7.09082H18.9455C19.1042 7.09082 19.2331 7.21979 19.2331 7.37846V12.3669C19.2331 12.526 19.1042 12.6549 18.9455 12.6549H13.957C13.798 12.6549 13.669 12.526 13.669 12.3669V7.37846C13.669 7.21941 13.798 7.09082 13.957 7.09082ZM18.6579 7.66648H14.2451V12.0793H18.6579V7.66648ZM12.0793 7.66648H7.66648V12.0793H12.0793V7.66648Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#F3223C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17676 9.17651L16.8238 16.8236M16.8238 9.17651L9.17676 16.8236",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitBurgerSettingsIco);
export default __webpack_public_path__ + "static/media/exitBurgerSettingsIco.d549ad6291c7c1f6ae91401b9e16c3cf.svg";
export { ForwardRef as ReactComponent };